import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Planning, Storage } from 'actions';
import { Header, Segment, Feature, NeuCard } from 'components';
import { colors } from 'utils/colors';
import { PLANNING_ACCUMULATION, PLANNING_DECUMULATION } from 'utils/features';
import asset4 from 'images/asset_4.png';

@withRouter
@connect((state) => ({
  account: state.CustomAccount.account,
  partnerName: state.Storage['partner-name'],
}))
class Landing extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(Planning.clearPlanning());
    dispatch(Storage.removeItem('cache-pwpa-blueprint'));
    dispatch(Storage.removeItem('cachePB'));
    dispatch(Storage.removeItem('cachePB'));
    dispatch(Storage.removeItem('cacheTW'));
    dispatch(Storage.removeItem('cacheWR'));
    dispatch(Storage.removeItem('cacheTS'));
    dispatch(Storage.removeItem('cacheSR'));
  }

  render() {
    const { partnerName } = this.props;

    return (
      <Segment flex>
        <div>
          <img src={asset4} height="80" width="120" alt="Portfolio" />
          <Header size="1.5rem" color="black">
            Welcome to Planning
          </Header>
          <P>
            {partnerName === 'quotemedia_pro'
              ? 'We have crafted unique tools separately for the accumulation and the decumulation phases of retirement planning, such as calculating target wealth at retirement, monthly target savings, and tax-optimized drawdown.'
              : 'We have crafted tools for the accumulation phase of retirement planning, such as calculating target wealth at retirement, and monthly target savings.'}
          </P>

          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Feature name={PLANNING_ACCUMULATION}>
              <NeuCard
                to="/planning/accumulation"
                iconName="double angle up"
                title="Accumulation"
                description="Tools to help you make better saving and investment decisions as you build wealth during your working years."
                color={colors.orange}
              />
            </Feature>
            <Feature name={PLANNING_DECUMULATION}>
              <NeuCard
                to="/planning/decumulation"
                iconName="double angle down"
                title="Decumulation"
                description="Tools for retirees who are drawing down their savings for their retirement spending needs."
                color={colors.orange}
              />
            </Feature>
          </div>
        </div>
      </Segment>
    );
  }
}

export default Landing;

Landing.propTypes = {
  dispatch: PropTypes.func.isRequired,
  partnerName: PropTypes.string,
};

Landing.defaultProps = {
  partnerName: '',
};

const P = styled.p`
  color: rgba(0, 0, 0, 0.5) !important;
  max-width: 650px;
  margin: 0 auto 3rem auto;

  &.strike {
    text-decoration: line-through;
  }
`;
